"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.data = [
    {
        description: 'The tour is created',
        id: 1,
        name: 'CREATED',
    },
    {
        description: 'The tour is planned',
        id: 2,
        name: 'PLANNED',
    },
    {
        description: 'The tour is in transit',
        id: 3,
        name: 'IN_TRANSIT',
    },
    {
        description: 'The tour is completed',
        id: 4,
        name: 'COMPLETED',
    },
    {
        description: 'The tour is discarded',
        id: 5,
        name: 'DISCARDED',
    },
    {
        description: 'The tour is incomplete',
        id: 6,
        name: 'INCOMPLETE',
    },
];
